import React from 'react';
import Types from '../../models/components/loading';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import loadersvg from './static/images/loader-logo.svg';

let _common: Common;
const _logger = Log.create('Loading.tsx');
const T = Translator.create();

export class LoginLoading extends React.Component<Types.IStandartPopup, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <div className="site-loader-login">
                <div className="loader-container">
                    <div className="circle">
                        {/* <img src={loadersvg} /> */}
                        <div></div>
                    </div>

                </div>
            </div>
        );
    }
}


export default LoginLoading;
